import React, { useEffect, useState } from 'react';
import FlatList from 'flatlist-react';
import DrawerCustom from '../../components/DrawerCustom';
import ButtonCustom from '../../components/ButtonCustom';
import { withTranslation } from 'react-i18next';
import { withStyles } from '@material-ui/core/styles';
import Typo from '../../components/CustomTypo';
import { Grid, InputBase } from '@material-ui/core';
import { dataUtil, usage_type } from '../../wsclient/crmservices/dataUtil';
import { AddCommentIcon, BackOnPrimaryIcon, DeliveryIcon, DeleteWhiteIcon, WalletWhiteIcon, SwichGreenActiveIcon, SwichIcon, CardIcon, EditWhiteMDIcon, RadioCheckedWhiteIcon, VisaIcon, MasterIcon, RadioCheckedIcon, RadioIcon, PaypalIcon, VNPayIcon, PlusIcon, MinusIcon, StripeIcon, DowngradeIcon, DownIcon, UpIcon, ArrowRightFAIcon } from '../../components/icons'
import { getAppCfg, getCurrency, getLogo } from '../../utils/common';
import InfiniteScroll from 'react-infinite-scroll-component';
import CrossellProductsComponent from './CrossellProductsComponent';
import CustomizedCircularProgress from '../../components/CircularProgress';
import FormSerialOTP from '../../components/FormSerialOTP';
import { connection, domainName, portal_config } from '../../../portal.config';
import { Currencies } from '../../../Currencies';
import { formatDateToDDMMYYYYFrEpoch, getCurrencySymbol } from '../../utils/util';
import Divider from '../../components/Divider';

const styles = theme => ({
    container: {
        padding: theme.spacing(3, 8, 3, 8),
        [theme.breakpoints.down('xs')]: {
            padding: theme.spacing(3, 5, 3, 5)
        }
    },
    buttonBack: {
        width: theme.spacing(10),
        height: theme.spacing(10),
        backgroundColor: domainName === 'buyway' ? 'none' : theme.palette.background.tertiary,
        borderRadius: theme.spacing(8),
        cursor: "pointer",
        textAlign: "center",
        touchAction: "manipulation",
        position: 'absolute',
        top: theme.spacing(5),
        right: theme.spacing(5),
        display: "flex",
        alignItems: "center",
        justifyContent: "center"
    },
    cart_content: {
        marginTop: theme.spacing(20)
    },
    footer: {
        position: 'fixed',
        bottom: theme.spacing(5),
        width: '47%',// lấy chỉ số width ở drawer x 90%
        [theme.breakpoints.down('md')]: {
            width: '54%'
        },
        [theme.breakpoints.down('sm')]: {
            width: '63%'
        },
        [theme.breakpoints.down('xs')]: {
            width: '81%'
        }
    },
    footerWithAddNote: {
        position: 'absolute',
        bottom: theme.spacing(15),
        width: '90%',
    },
    item_image: {
        width: 50,
        height: 50,
        objectFit: 'containt',
        borderRadius: 50,
        [theme.breakpoints.down('xs')]: {
            width: 40,
            height: 40,
        }
    },
    item_image_container: {
        width: 60,
        height: 60,
        borderRadius: 60,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        marginRight: theme.spacing(5),
        backgroundColor: theme.palette.background.secondary,
        [theme.breakpoints.down('xs')]: {
            width: 45,
            height: 45,
            marginRight: theme.spacing(3),
        }
    },
    item_icon_container: {
        marginLeft: 10,
        width: 40,
        height: 40,
        borderRadius: 40,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        marginRight: theme.spacing(5) + 10,
        backgroundColor: theme.palette.background.tertiary,
    },
    item: {
        // padding: theme.spacing(0,5,0,5),
        // margin: theme.spacing(2, 0),
    },
    add_note: {
        margin: theme.spacing(5, 0, 5, 0),
        cursor: 'pointer',
    },
    add_note_content: {
        minHeight: theme.spacing(20),
        backgroundColor: theme.palette.background.secondary,
        borderRadius: theme.spacing(4),
        padding: theme.spacing(4),
        marginBottom: theme.spacing(4),
        border: '1px solid ' + theme.palette.background.card,
    },
    additional_info: {
        minHeight: theme.spacing(20),
        backgroundColor: theme.palette.background.secondary,
        borderRadius: theme.spacing(4),
        padding: theme.spacing(4),
        marginBottom: theme.spacing(4),
        border: '1px solid ' + theme.palette.background.card,
        width:'60%'
    },
    button_Place: {
        margin: theme.spacing(4, 0, 0, 0)
    },
    bg_icon: {
        width: theme.spacing(6),
        height: theme.spacing(6),
        borderRadius: theme.spacing(6),
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        backgroundColor: theme.palette.icon.trash,
        cursor: "pointer",
        touchAction: "manipulation",
    },
    bg_square: {
        // width: theme.spacing(6),
        // height: theme.spacing(6),
        borderRadius: theme.spacing(1),
        backgroundColor: theme.palette.background.secondary,
        // /marginRight: main_styles.margin.mg_unit3x,
        justifyContent: 'center',
        alignItems: "center"
    },
    bt_funds: {
        cursor: 'pointer'
    },
    payment: {
        cursor: 'pointer',
        marginTop: theme.spacing(4),
        marginLeft: theme.spacing(3),
        position: 'relative',
        zIndex: 9,
    },
    inputFund: {
        backgroundColor: theme.palette.background.secondary,
        borderRadius: theme.spacing(1),
        padding: theme.spacing(1),
        width: theme.spacing(18),
        height: theme.spacing(10),
        fontSize: theme.spacing(5),
        border: '1px solid ' + theme.palette.background.card,
    },
    wraptext: {
        lineHeight: '1.25em',
        // height:'2em',
        overflow: "hidden",
        textOverflow: 'ellipsis',
        display: '-webkit-box',
        '-webkit-line-clamp': 2,
        '-webkit-box-orient': 'vertical'
    },
    notes: {
        width: 400,
        [theme.breakpoints.down('lg')]: {
            width: 300,
        },
        [theme.breakpoints.down('xs')]: {
            width: 150,
        }
    },
    method_container: {
        padding: theme.spacing(3, 0, 0, 0)
    },
    method: {
        backgroundColor: theme.palette.background.secondary,
        borderRadius: theme.spacing(2),
        padding: theme.spacing(1.5, 3, 1, 3),
        cursor: 'pointer',
        height: theme.spacing(10),
        border: '1px solid ' + theme.palette.background.card,
    },
    list_cards: {
        backgroundColor: theme.palette.background.secondary,
        borderRadius: theme.spacing(2),
        padding: theme.spacing(3),
        cursor: 'pointer',
        border: '1px solid ' + theme.palette.background.card,
    },
    card_item: {
        height: theme.spacing(10),
        padding: theme.spacing(1.5, 3, 1, 3),
    },
    textLight: {
        color: theme.palette.text.light,
    },
    line: {
        margin: theme.spacing(2, 0)
    }
})

function CartsView(props) {
    const [showCardsStripe, setShowCardsstripe] = useState(true);
    const [showPaypal, setShowPaypal] = useState(true);

    const { classes, t, currency, open, onClose, carts, estimate_order_result, showAddNote, onClickAddNote, handleOnChangeAddNote, notes, estimate_cart_items, onAddCard, onChangeCard } = props;
    var deliveryItem = estimate_order_result && estimate_order_result.invoice_estimate && estimate_order_result.invoice_estimate.line_items.length > 1 ? dataUtil.getDeliveryItem(estimate_order_result.invoice_estimate.line_items) : null;


    const appConfig = getAppCfg()

    var invoice_estimate = estimate_order_result && estimate_order_result.invoice_estimate ? estimate_order_result.invoice_estimate : null;
    var allow_wallet_funds_payment = appConfig && appConfig.features && appConfig.features.ordering_details && appConfig.features.ordering_details.allow_wallet_funds_payment;
    var allow_specific_funds_amount = appConfig && appConfig.features && appConfig.features.ordering_details && appConfig.features.ordering_details.allow_specific_funds_amount;
    console.log('estimate_order_result===', estimate_order_result)
    let order_summary = dataUtil.getOrderSummary(estimate_order_result, props.isUseWalletFund, props.request_amount_from_wallet_funds, props.isValidAmountWalletFund);
    
    let service_delivery_estimate = estimate_order_result.service_delivery_estimate && estimate_order_result.service_delivery_estimate.length > 0 ? estimate_order_result.service_delivery_estimate[0] : null;
    let serviceToAdd = service_delivery_estimate && service_delivery_estimate.services_to_add ? service_delivery_estimate.services_to_add : [];  
    let trialPeriod=null;
    for(let i=0;i<serviceToAdd.length;i++){
        if(serviceToAdd[i].trial_period!=null){
            trialPeriod=serviceToAdd[i].trial_period
        }
    }
    //let trialPeriod =serviceToAdd[0].trial_period ? serviceToAdd[0].trial_period : null;
    let billing_estimate = service_delivery_estimate && service_delivery_estimate.billing_estimate ? service_delivery_estimate.billing_estimate : null;
    let billing_period = service_delivery_estimate && service_delivery_estimate.billing_estimate && service_delivery_estimate.billing_estimate.billed_period ? service_delivery_estimate.billing_estimate.billed_period : null;
    
    var payment_label = t('select_payment_method')
    var payment_sub_label = t('Tap_here_to_continue')
    if (props.paymentMethod === 'CASH') {
        if (props.order_type === 'DELIVERY')
            payment_label = t('Cash_on_delivery')
        else
            payment_label = t('Cash_on_pikup')

        payment_sub_label = ''//t('Please_check_cash')
    }
    else if (props.paymentMethod === 'CARD' && props.primary_card) {
        payment_label = t('Card') + '**** **** ****' + (props.primary_card.card ? props.primary_card.card.last4 : "")
        payment_sub_label = ''//t('Please_check_card')
    }
    else if (props.paymentMethod === 'VNPAY') {
        payment_label = t('Payment with VNPay')
        payment_sub_label = ''
    }
    else if (props.paymentMethod === 'WALLET') {
        payment_label = t('Payment with Paypal')
        payment_sub_label = ''
    }
    let isTermedOrUsage=false;
    for(let i=0;i<estimate_cart_items.length;i++){
        if(estimate_cart_items[i].classification==='TERMED_SERVICE'|| estimate_cart_items[i].classification==='USAGE_SERVICE'){
            isTermedOrUsage=true;
        }
    }
    let showAmountDue = true;
    if(estimate_cart_items && estimate_cart_items.length > 0){
        let existOtherProduct = estimate_cart_items.filter(x => x.classification != 'TERMED_SERVICE' && x.classification != 'USAGE_SERVICE');
        if(existOtherProduct && existOtherProduct.length > 0) showAmountDue = true;
        else showAmountDue = false;
    }

    console.log("estimate_cart_items:", estimate_cart_items);
    console.log("estimate_order_result:", estimate_order_result);
    console.log("payment_method===", props.payment_method);
    console.log("paymentMethod===", props.paymentMethod);
    console.log("primary_paypal===", props.primary_paypal);
    console.log('CartsView crosssellProducts======',props.crosssellProducts)
    console.log('CartsView order_type======',props.order_type)
    console.log('service_delivery_estimate',service_delivery_estimate)
    let { subTotalAmount, totalAmount, wallet_funds_amount, amountDue, total_discount_amount, pay_at_next_bill, pay_upfront } = order_summary;
    if(props.order_type === 'DIRECT_SALE'){
        subTotalAmount = totalAmount;
    }
    let isAllowOrder = false;
    if(estimate_order_result && estimate_order_result.order_estimate && estimate_order_result.order_estimate.ordering_allowed){
        isAllowOrder = true;
    }
    if(!props.paymentMethod || (props.paymentMethod === 'CARD' && !props.primary_card) || (props.paymentMethod === 'WALLET' && !props.primary_paypal)){
        isAllowOrder = true;
    }
    return (
        <DrawerCustom large fullScreen open={open} onClose={onClose}>
            <Grid xs={12} item className={classes.container}>
                <Grid xs={12} item container justify='flex-end' onClick={() => props.onGoBack('menu')}>
                    <Grid color='gray' className={classes.buttonBack}>
                        <BackOnPrimaryIcon />
                    </Grid>
                </Grid>
                <Grid xs={12} item >
                    <Typo mg_top_lg variant='h3' light>{isTermedOrUsage ? t('Checkout') : t('cart')}</Typo>
                </Grid>
                <Grid xs={12} item style={{paddingBottom: 50}} className={classes.cart_content}>
                    <InfiniteScroll dataLength={estimate_cart_items.length} height={showAddNote ? '60vh' : '70vh'}>
                        {/* items */}
                        <CartContent cart={estimate_cart_items} classes={classes} t={t} currency={currency} onRemoveItem={props.onRemoveItem} editCartItem={props.editCartItem} onItemQuantityChange={props.onItemQuantityChange}/>
                        {props.loadingCrosssell && <CustomizedCircularProgress />}
                        {/* Note */}
                        { isTermedOrUsage ? 
                        <Grid item xs={12} className={classes.additional_info}>
                            {trialPeriod && <Typo>{t('trial_period')} {formatDateToDDMMYYYYFrEpoch(trialPeriod.starts_on)}-{formatDateToDDMMYYYYFrEpoch(trialPeriod.ends_on)}</Typo>}
                            {billing_period &&<Typo>{t('billing_period')} {formatDateToDDMMYYYYFrEpoch(billing_period.from_date)}-{formatDateToDDMMYYYYFrEpoch(billing_period.to_date)}</Typo>}
                            {billing_estimate && <Typo>{t('next_billing_date')} {formatDateToDDMMYYYYFrEpoch(billing_estimate.billing_date)}</Typo>}
                            {billing_estimate && <Typo>{t('next_billing_amount')} {currency}{billing_estimate.totals.total_amount ? billing_estimate.totals.total_amount.toFixed(2) : "0.00"}</Typo>}
                            {service_delivery_estimate && <Typo>{t('next_payment_due')} {formatDateToDDMMYYYYFrEpoch(service_delivery_estimate.next_payment_date)}</Typo>}
                        </Grid>:<></>
                        }
                        <Grid item xs={12} container direction='row' className={classes.add_note} onClick={onClickAddNote} id="btn_cart_add_note">
                            <AddCommentIcon />
                            <Typo mg_left_md variant='subtitle1' light>{t('add_notes')}</Typo>
                        </Grid>
                        {showAddNote && <Grid item xs={12} className={classes.add_note_content}>
                            <InputBase id="cart_note" multiline color='primary' fullWidth autoFocus placeholder={t('note_place_holder')} value={notes} onChange={(event) => handleOnChangeAddNote(event)} />
                        </Grid>}
                        {deliveryItem && <DeliveryItem item={deliveryItem} classes={classes} t={t} currency={currency} />}
                        {/* recommendations */}
                        {props.crosssellProducts && props.crosssellProducts.length > 0 && <CrossellProductsComponent currency={props.currency} crossellProducts={props.crosssellProducts} onSelectCrossellProduct={props.onSelectCrossellProduct} />}
                        {/* <Grid item xs={12} container onClick={props.onSelectPaymentMethod} className={classes.payment} direction='row'>
                            <CardIcon />
                            <Grid item>
                                <Typo mg_left_xs variant='subtitle2' color='onPrimary'>{payment_label}</Typo>
                                <Typo mg_left_xs variant='body2' color='label'>{payment_sub_label}</Typo>
                            </Grid>
                        </Grid> */}
                        {domainName !== 'ayna' && props.payment_method_types && props.payment_method_types.map((type, index) => {
                            if (type == 'CASH' || type == 'CARD') {
                                return (
                                    <Grid xs={12} key={index} item>
                                        <Grid xs={12} item className={classes.method_container} onClick={() => props.onSelectPaymentMethod(type)} data-cart-method-type={type} data-cart-method-id={props.primary_card ? props.primary_card.id : type}>
                                            <Grid xs={12} item className={classes.method} container alignItems='center' >
                                                <Grid xs={1} sm={1} item>
                                                    {props.paymentMethod === type ? <RadioCheckedIcon /> : <RadioIcon />}
                                                </Grid>
                                                <Grid xs={1} sm={1} item>
                                                    <Typo mg_left_xs variant='body1'>{type === 'CARD' ? t('cards') : t('cash')}</Typo>
                                                </Grid>
                                                {type === 'CARD' && <Grid xs={6} sm={7} item container justify='center'>
                                                    {props.primary_card && <Typo mg_left_xs variant='body1'>**** **** **** {props.primary_card.card.last4}</Typo>}
                                                </Grid>}
                                                {type === 'CARD' && props.primary_card && <Grid xs={2} sm={2} item container justify='flex-end'><VisaIcon /></Grid>}
                                                {type === 'CARD' && props.primary_card && <Grid xs={2} sm={1} item container justify='flex-start'><MasterIcon /></Grid>}

                                            </Grid>
                                        </Grid>
                                        {/* {type === 'CARD' && !props.primary_card && <Grid xs={12} item container justify='flex-end'><Typo color='onPrimary' onClick={onAddCard}>+ {t('add_a_card')}</Typo></Grid>} */}                                        
                                        {/* {type === 'CARD' && <Grid xs={12} item container justify='flex-end' style={{ cursor: 'pointer' }}><Typo mg_top_md onClick={() => onChangeCard()} color='onPrimary'>{t('manage_card')}</Typo></Grid>} */}
                                    </Grid>
                                )
                            }
                        })}

                        {domainName !== 'ayna' && connection.crmConfig.isOpenPaypal && <Grid xs={12} item>
                            <Grid xs={12} item className={classes.method_container} onClick={() => props.onSelectPaymentMethod("WALLET")} data-cart-method={'wallet'}>
                                <Grid xs={12} item className={classes.method} container alignItems='center' >
                                    <Grid xs={1} sm={1} item>
                                        {props.paymentMethod === "WALLET" ? <RadioCheckedIcon /> : <RadioIcon />}
                                    </Grid>
                                    <Grid xs={2} item>
                                        <PaypalIcon style={{ width: 80, height: 30, objectFit: 'contain' }} />
                                    </Grid>

                                    <Grid xs={9} item justifyContent='flex-end' container>
                                        <Typo variant='body1'> {props.primary_paypal && props.primary_paypal.wallet && props.primary_paypal.wallet.email ? props.primary_paypal.wallet.email : ''}</Typo>
                                    </Grid>

                                </Grid>
                            </Grid>

                        </Grid>}
                        {portal_config.isLocationVN && <Grid xs={12} item>
                            <Grid xs={12} item className={classes.method_container} onClick={() => props.onSelectPaymentMethod("VNPAY")}>
                                <Grid xs={12} item className={classes.method} container alignItems='center' >
                                    <Grid xs={1} sm={1} item>
                                        {props.payment_method === "VNPAY" ? <RadioCheckedIcon /> : <RadioIcon />}
                                    </Grid>
                                    <Grid xs={2} item>
                                        <VNPayIcon style={{ width: 80, height: 40, objectFit: 'contain' }} />
                                    </Grid>

                                    <Grid xs={9} item justifyContent='flex-end' container>
                                    </Grid>

                                </Grid>
                            </Grid>
                        </Grid>}
                        {domainName !== 'ayna' && props.payment_method_types && props.payment_method_types.includes('CARD') && <Grid xs={12} item container justify='flex-end' style={{ cursor: 'pointer' }}>
                                <Typo mg_top_md onClick={() => onChangeCard()} light id="btn_cart_change_card">{t('manage_card')}</Typo>
                            </Grid>
                        }
                        {domainName === 'ayna' && !document._portalConfig.usePaymentLocal && <Grid item xs={12}>
                            <Grid xs={12} item className={classes.method_container}>
                                {connection.crmConfig.isOpenStripe && <Grid item xs={12} className={classes.list_cards} >
                                    <Grid xs={12} item container alignItems='center' onClick={() => setShowCardsstripe(!showCardsStripe)}>
                                        <Grid xs={10} item>
                                            <Typo mg_left_xs variant='body1'>{t('Cards Stripe')}</Typo>
                                        </Grid>
                                        <Grid item xs={2} style={{textAlign: 'right'}}>
                                            {showCardsStripe ? <UpIcon /> : <DownIcon />}
                                        </Grid>
                                    </Grid>
                                    {showCardsStripe && props.cardsStripe && props.cardsStripe.length > 0 && props.cardsStripe.map((item, index) => {
                                        return (
                                            <Grid item xs={12} container className={classes.card_item} alignItems='center' key={index} onClick={() => {
                                                props.setPaymentSelected(item.id);
                                                props.setPrimaryCard(item);
                                                props.onSelectPaymentMethod('CARD');
                                            }}>
                                                <Grid xs={1} sm={1} item>
                                                    {props.paymentSelected === item.id ? <RadioCheckedIcon /> : <RadioIcon />}
                                                </Grid>
                                                <Grid xs={1} sm={1} item>
                                                    <Typo mg_left_xs variant='body1'>
                                                        <StripeIcon style={{ width: 80, height: 30, objectFit: 'contain' }} />
                                                    </Typo>
                                                </Grid>
                                                <Grid xs={6} sm={7} item container justify='center'>
                                                    {item.card && item.card.last4 && <Typo mg_left_xs variant='body1'>**** **** **** {item.card.last4}</Typo>}
                                                </Grid>
                                                {item.card && item.card.brand === 'MASTERCARD' && <Grid xs={2} sm={2} item container justify='flex-end'><MasterIcon /></Grid>}
                                                {item.card && item.card.brand === 'VISACARD' && <Grid xs={2} sm={2} item container justify='flex-end'><VisaIcon /></Grid>}
                                            </Grid>
                                        );
                                    })}
                                </Grid>}
                                {connection.crmConfig.isOpenPaypal && <Grid item xs={12} className={classes.list_cards} style={{marginTop: 10}}>
                                    <Grid xs={12} item container alignItems='center' onClick={() => setShowPaypal(!showPaypal)}>
                                        <Grid xs={10} item>
                                            <Typo mg_left_xs variant='body1'>{t('Cards PayPal')}</Typo>
                                        </Grid>
                                        <Grid item xs={2} style={{textAlign: 'right'}}>
                                            {showPaypal ? <UpIcon /> : <DownIcon />}
                                        </Grid>
                                    </Grid>
                                    {showPaypal && props.cardsPaypal && props.cardsPaypal.length > 0 && props.cardsPaypal.map((item, index) => {
                                        return (
                                            <Grid item xs={12} container className={classes.card_item} alignItems='center' key={index} onClick={() => {
                                                props.setPaymentSelected(item.id);
                                                props.setPrimaryPaypal(item);
                                                props.onSelectPaymentMethod('WALLET');
                                            }}>
                                                <Grid xs={1} sm={1} item>
                                                    {props.paymentSelected === item.id ? <RadioCheckedIcon /> : <RadioIcon />}
                                                </Grid>
                                                <Grid xs={1} sm={1} item>
                                                    <Typo mg_left_xs variant='body1'>
                                                        <PaypalIcon style={{ width: 80, height: 30, objectFit: 'contain' }} />
                                                    </Typo>
                                                </Grid>
                                                <Grid xs={6} sm={7} item container justify='center'>
                                                    <Typo variant='body1'> {item.wallet && item.wallet.email ? item.wallet.email : ''}</Typo>
                                                </Grid>
                                            </Grid>
                                        );
                                    })}
                                </Grid>}
                            </Grid>
                        </Grid>}
                        {domainName === 'ayna' && document._portalConfig.usePaymentLocal && <Grid item xs={12}>
                            <Grid xs={12} item>
                                <Grid xs={12} item className={classes.method_container} onClick={() => props.onSelectPaymentMethod("CASH")}>
                                    <Grid xs={12} item className={classes.method} container alignItems='center' >
                                        <Grid xs={1} sm={1} item>
                                            {props.paymentMethod === "CASH" ? <RadioCheckedIcon /> : <RadioIcon />}
                                        </Grid>
                                        <Grid xs={11} sm={11} item>
                                            <Typo mg_left_xs variant='body1'>{t('SSLCommerz')}</Typo>
                                        </Grid>
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Grid>}
                        {allow_wallet_funds_payment && <Grid xs={12} item container justify='flex-end' alignItems='flex-end' className={classes.item}>
                            <Grid xs={9} lg={10} item container direction='row' justify='flex-end' alignItems='flex-end'>
                                <WalletWhiteIcon />
                                <Typo mg_left_md variant='body1' light>{t('use_funds_from_wallet')}:</Typo>
                            </Grid>
                            <Grid xs={3} lg={2} item container justify='flex-end' alignItems='flex-end'>
                                <Grid item onClick={() => props.onUseWalletFund()} className={classes.bt_funds} id="btn_cart_use_wallet_fund">
                                    {props.isUseWalletFund ? <SwichGreenActiveIcon /> : <SwichIcon />}
                                </Grid>
                            </Grid>
                        </Grid>}
                        {props.isUseWalletFund && <Grid xs={12} item container justify='flex-end' alignItems='center' className={classes.item}>
                            <Grid xs={9} lg={10} item container direction='row' justify='flex-end' alignItems='flex-end'>
                                <Typo variant='body1' light>{t('to_be_paid_with_funds')}:</Typo>
                            </Grid>
                            <Grid xs={3} lg={2} item container justify='flex-end' alignItems='center'>
                                {allow_specific_funds_amount && !props.edit_amount_form && order_summary.wallet_funds_amount > 0 && <Grid item className={classes.bt_funds} onClick={() => props.onShowEditWalletFundAmount('edit')} id="btn_cart_edit_wallet_fund_amount">
                                    <Typo style={{ textTransform: 'uppercase'}}>{""} {t("btn_edit")}</Typo>
                                </Grid>}
                                <Typo mg_left_md variant='h6' light>{'- '}{currency}{order_summary.wallet_funds_amount ? order_summary.wallet_funds_amount.toFixed(2) : "0.00"}</Typo>
                            </Grid>
                        </Grid>}
                        {props.edit_amount_form && <Grid xs={12} item container justify='flex-end' alignItems='flex-end' className={classes.item}>
                            <Grid xs={9} lg={10} item container direction='row' justify='flex-end' alignItems='flex-end'>
                                <ButtonCustom color="onPrimary" size='sm' onClick={() => props.onShowEditWalletFundAmount('cancel')} id="btn_cart_wallet_fund_cancel">{t('Cancel')}</ButtonCustom>
                                <ButtonCustom color='primary' size='sm' onClick={() => props.onShowEditWalletFundAmount('save')} disabled={!props.isValidAmountWalletFund} id="btn_cart_wallet_fund_save">{t('Save')}</ButtonCustom>
                            </Grid>
                            <Grid xs={3} lg={2} item container justify='flex-end' alignItems='flex-end'>
                                <InputBase id="wallet_fund_amount" type='number' color='primary' fullWidth className={classes.inputFund} autoFocus value={props.input_field_value} onChange={(event) => props.handleChangeNumberFund(event.target.value)} />
                            </Grid>
                        </Grid>}
                        {/* {domainName == 'homespot' && <FormSerialOTP />} */}
                        {pay_upfront && <Grid item xs={12}>
                            <Divider className={classes.line}/>
                            <Grid item xs={9} lg={10} container justifyContent='flex-end'>
                                <Typo variant='h6' light>{t('Pay upfront')}</Typo>
                            </Grid>
                            <Grid xs={12} item container justify='flex-end' alignItems='flex-end' className={classes.item}>
                                <Grid xs={9} lg={10} item container direction='row' justify='flex-end' alignItems='flex-end'>
                                    <Typo variant='body1' light>{t('sub_total')}:</Typo>
                                </Grid>
                                <Grid xs={3} lg={2} item container justify='flex-end' alignItems='flex-end'>
                                    <Typo mg_left_md variant='h6' light>{currency}{subTotalAmount.toFixed(2)}</Typo>
                                </Grid>
                            </Grid>
                            {props.isValidAmountWalletFund === false && <Grid xs={12} item container justify='flex-end' alignItems='flex-end' className={classes.item}>
                                <Typo mg_left_md variant='body2' color='error'>{t('REQUEST_WALLET_FUNDS_AMOUNT_INVALID')}{props.availabelWalletFund ? props.availabelWalletFund.toFixed(2) : '0.00'}</Typo>
                            </Grid>}
                            {order_summary.total_discount_amount > 0 && <Grid xs={12} item container justify='flex-end' alignItems='flex-end' className={classes.item}>
                                <Grid xs={9} lg={10} item container direction='row' justify='flex-end' alignItems='flex-end'>
                                    <Typo variant='body1' light>{t('promotion_discount')}:</Typo>

                                </Grid>
                                <Grid xs={3} lg={2} item container justify='flex-end' alignItems='flex-end'>
                                    <Typo mg_left_md variant='h6' light>{'- '}{currency}{total_discount_amount ? total_discount_amount.toFixed(2) : "0.00"}</Typo>
                                </Grid>
                            </Grid>}
                            {showAmountDue && <Grid xs={12} item container justify='flex-end' alignItems='flex-end' className={classes.item}>
                                <Grid xs={9} lg={10} item container direction='row' justify='flex-end' alignItems='flex-end'>
                                    <Typo variant='body1' light>{t('amount_due')}:</Typo>

                                </Grid>
                                <Grid xs={3} lg={2} item container justify='flex-end' alignItems='flex-end'>
                                    <Typo mg_left_md variant='h5' light>{currency}{amountDue ? amountDue.toFixed(2) : "0.00"}</Typo>
                                </Grid>
                            </Grid>}
                        </Grid>}
                        {pay_at_next_bill && <Grid item xs={12}>
                            <Divider  className={classes.line}/>
                            <Grid item  xs={9} lg={10} container justifyContent='flex-end'>
                                <Typo variant='h6' light>{t('Pay at next bill')}</Typo>
                            </Grid>
                            <Grid item xs={12} container justifyContent='flex-end' alignItems='flex-end'>
                                <Grid xs={9} lg={10} item container direction='row' justify='flex-end' alignItems='flex-end'>
                                    <Typo variant='body1' light>{t('sub_total')}:</Typo>
                                </Grid>
                                <Grid xs={3} lg={2} item container justify='flex-end' alignItems='flex-end'>
                                    <Typo mg_left_md variant='h6' light>{currency}{pay_at_next_bill.total_amount ? pay_at_next_bill.total_amount.toFixed(2) : "0.00"}</Typo>
                                </Grid>
                            </Grid>
                            <Grid item xs={12} container justifyContent='flex-end' alignItems='flex-end'>
                                <Grid xs={9} lg={10} item container direction='row' justify='flex-end' alignItems='flex-end'>
                                    <Typo variant='caption' light>{t('Number of items')}:</Typo>
                                </Grid>
                                <Grid xs={3} lg={2} item container justify='flex-end' alignItems='flex-end'>
                                    <Typo mg_left_md variant='caption' light>{pay_at_next_bill.line_items ? pay_at_next_bill.line_items.length : 0}</Typo>
                                </Grid>
                            </Grid>
                        </Grid>}
                    </InfiniteScroll>
                </Grid>
                <Grid item xs={12} className={classes.footer} container>
                    <Grid item xs={12}>
                        <ButtonCustom fullWidth color='primary' 
                            onClick={() => props.onPlaceOrder(props.isValidAmountWalletFund, props.request_amount_from_wallet_funds, order_summary)} 
                            className={classes.button_Place} 
                            disabled={isAllowOrder ? false : true}
                            id="cart_btn_next_place_order"
                        >
                            {props.order_type === 'DIRECT_SALE' ? t('place_order') : t('btn_next') }
                        </ButtonCustom>
                    </Grid>
                </Grid>
            </Grid>
        </DrawerCustom>
    )
}

function DeliveryItem(props) {
    const { classes, t, item, currency } = props;
    //console.log('DeliveryItem====',item)
    return (
        <Grid xs={11} item container direction='row' className={classes.item}>
            <Grid xs={9} item container direction='row' alignItems='center'>
                <div className={classes.item_icon_container}>
                    <DeliveryIcon />
                </div>
                <Typo variant='subtitle1' light mg_right_lg />
                <Grid item>
                    <Typo variant='subtitle1' mg_left_lg light>{item.product.name}</Typo>
                </Grid>
            </Grid>
            <Grid xs={3} item container justify='flex-end' alignItems='center'>
                <Typo variant='subtitle1' light>{currency}{item.unit_price ? item.unit_price.toFixed(2) : "0.00"}</Typo>
            </Grid>
        </Grid>
    )
}

function CartItemImage(props) {
    if (props.image && props.image.url) {
        return <img className={props.classes.item_image} src={props.image.url} />
    } return <img className={props.classes.item_image} src={getLogo()} />;;
}

function CartContent(props) {
    
    const { classes, t, cart, currency, editCartItem, } = props;
    const getComponent = items => {
        var componentStr = '';
        items.forEach(item => {
            componentStr = componentStr + item.name + ", ";
        });
        if (componentStr) {
            componentStr = componentStr.substr(0, componentStr.length - 2);
        }
        return componentStr;
    }
    const getVariants = items => {
        var variantStr = '';
        items.forEach(item => {
            variantStr = variantStr + item.value + ", ";
        });
        if (variantStr) {
            variantStr = variantStr.substr(0, variantStr.length - 2);
        }
        return variantStr;
    }
    let currency_symbol = currency;
    return <FlatList
        list={cart}
        renderItem={(item) => {
            let price_selected = item.price_selected ? item.price_selected : null;
            currency_symbol = getCurrencySymbol(price_selected && price_selected.currency ? price_selected.currency : null);
            return (
                <Grid xs={12} item container direction='row' className={classes.item}>
                    <Grid xs={8} item container direction='row' alignItems='center' onClick={() => item.variations && item.type !== 'FLAT'  ? editCartItem(item) : undefined} data-cart-product-id={item.id} data-cart-product-name={item.name}>
                        <Grid item xs={2} >
                            <div className={classes.item_image_container}>
                                <CartItemImage classes={classes} image={dataUtil.getImageByUsageTypePortal(item.creatives, usage_type.product_item)} />
                            </div>
                        </Grid>
                        <Grid xs={6} item style={{ marginLeft: 16 }}>
                            <Grid xs={12} item>
                                <Typo variant='body2' light>{item.name}</Typo>
                            </Grid>
                            {item.variant_selected && item.variant_selected.length > 0 && <Grid xs={12} item><Typo variant='description' light>{getVariants(item.variant_selected)}</Typo></Grid>}
                            {item.components && item.components.length > 0 && <Grid xs={12} item><Typo variant='description' color='label'>{getComponent(item.components)}</Typo></Grid>}
                            <Grid xs={12}>
                                {item.notes && <Grid item xs={12} className={classes.notes}><Typo variant='description' light className={classes.wraptext}>{t('notes')} {item.notes}</Typo></Grid>}
                            </Grid>
                        </Grid>
                    </Grid>
                    <Grid xs={3} item container justify='flex-end' alignItems='center' >
                        <Grid item xs={8} sm={6} container justifyContent='flex-end' direction='row' alignItems='center'>
                            <Grid xs={4} item container justifyContent='center' onClick={() => props.onItemQuantityChange(item, false)} style={{ cursor: 'pointer' }} data-cart-product-increse-id={item.id}>
                                <MinusIcon className={classes.textLight}/>
                            </Grid>
                            <Grid xs={4} item container alignItems='center' justifyContent='center'>
                                <Typo variant='h6' light center>{item.quantity}</Typo>
                            </Grid>
                            <Grid xs={4} item container justifyContent='center' onClick={() => props.onItemQuantityChange(item, true)} style={{ cursor: 'pointer' }} data-cart-product-decrese-id={item.id}>
                                <PlusIcon className={classes.textLight}/>
                            </Grid>
                        </Grid>
                        <Grid item container justifyContent='flex-end' onClick={() => item.variations ? editCartItem(item) : undefined}>
                            <Typo variant='subtitle1' mg_right_xs light>{item.quantity}{' x '}{currency_symbol}{dataUtil.getTotalPerProduct(item).toFixed(2)}</Typo>
                        </Grid>
                    </Grid>
                    <Grid xs={1} item container justify='flex-end' alignItems='center'>
                        <div className={classes.bg_icon} onClick={() => props.onRemoveItem(item)} data-cart-product-delete-id={item.id}>
                            <DeleteWhiteIcon />
                        </div>
                    </Grid>

                </Grid>
            );
        }

        }
    />
}

export default withStyles(styles)(withTranslation()(CartsView))